import script from "./OrganizationContractEvaluations.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationContractEvaluations.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationContractEvaluations.vue?vue&type=style&index=0&id=3118a87e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3118a87e"]])

export default __exports__